/* eslint-disable react-hooks/exhaustive-deps */
import {
    Button,
    Pagination,
    Stack,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Typography,
    Box,
} from "@mui/material";
import { Container } from "@mui/system";
import React, { useEffect, useState } from "react";
import ReviewRequestItem from "../components/ReviewRequestItem";
import { fetchReviewRequests } from "../http/reviewRequestsAPI";
import { useNavigate } from "react-router-dom";
import { RATING_ROUTE } from "../utils/consts";
import PageHeader from "../components/PageHeader";

const ReviewsPage = () => {
    const [reviewRequests, setReviewRequests] = useState([]);
    const [filteredReviewRequests, setFilteredReviewRequests] = useState([]);
    const [page, setPage] = useState(1);
    const [pageCount, setPageCount] = useState(0);
    const [statusFilter, setStatusFilter] = useState("all");
    const navigate = useNavigate();

    const loadApplications = () => {
        fetchReviewRequests(page).then((data) => {
            setPageCount(+data.totalPages);
            setReviewRequests(data.content);
        });
    };

    useEffect(() => {
        loadApplications();
    }, [page]);

    useEffect(() => {
        applyFilter();
    }, [reviewRequests, statusFilter]);

    const applyFilter = () => {
        let filtered = reviewRequests;

        if (statusFilter === "pending") {
            filtered = reviewRequests.filter((app) => app.decision === null);
        } else if (statusFilter === "processed") {
            filtered = reviewRequests.filter((app) => app.decision !== null);
        }

        setFilteredReviewRequests(filtered);
    };

    const handleChange = (event, value) => {
        if (page === value) {
            return;
        }
        setPage(value);
    };

    const handleFilterChange = (event) => {
        setStatusFilter(event.target.value);
    };

    return (
        <Container>
            <Typography variant="h6" sx={{ mt: 2, mb: 2 }}>
                Отзывы
            </Typography>

            <PageHeader
                showDivider={true}
                cardSx={{ justifyContent: "flex-start", mb: 2 }}
                left={
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 2,
                            flexWrap: "wrap",
                        }}
                    >
                        <Typography>Фильтры</Typography>
                        <FormControl sx={{ width: 220 }}>
                            <InputLabel id="statusLabel">Статус</InputLabel>
                            <Select
                                labelId="statusLabel"
                                value={statusFilter}
                                label="Статус"
                                size="small"
                                sx={{
                                    "& .MuiSelect-select": { py: 0.75 },
                                }}
                                onChange={handleFilterChange}
                            >
                                <MenuItem value="all">Все</MenuItem>
                                <MenuItem value="pending">
                                    Ожидают решения
                                </MenuItem>
                                <MenuItem value="processed">
                                    Обработанные
                                </MenuItem>
                            </Select>
                        </FormControl>
                    </Box>
                }
                right={
                    <Button
                        variant="contained"
                        onClick={() => navigate(RATING_ROUTE)}
                    >
                        РЕЙТИНГ
                    </Button>
                }
            />

            <Box
                sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    flexDirection: "row",
                    flexWrap: "wrap",
                    p: 0,
                    width: "100%",
                }}
            >
                {filteredReviewRequests.map((reviewRequest) => (
                    <ReviewRequestItem
                        key={reviewRequest.id}
                        reviewRequest={reviewRequest}
                        onUpdate={loadApplications}
                    />
                ))}
            </Box>
            <Stack sx={{ mt: 2, alignItems: "flex-start" }} spacing={2}>
                <Pagination
                    count={pageCount}
                    page={page}
                    onChange={handleChange}
                />
            </Stack>
        </Container>
    );
};

export default ReviewsPage;
